<template>
  <molecule-modal-dialog
    :modalId="modalId"
    buttonTextLeft="Confirm"
    buttonColorLeft="primary"
    textTitle="Site Access"
    textSubtitle="Share site with all menu"
    :isSlotBody="true"
    :isCloseOnBackDrop="false"
    :isDisableButtonLeft="countOfSelected === 0"
    @clickButtonLeft="confirmSelect"
    @clickButtonRight="cancelSiteSelect"
    @clickIconClose="cancelSiteSelect"
  >
    <template #body>
      <div class="w-100 px-md-5">
        <div class="mt-2">
          <div class="d-flex align-items-center justify-content-between">
            <div class="d-flex align-items-center modal-site__label">
              {{ siteList.length }} Site Access
              <div
                class="modal-site__check pl-1"
                @click="handleSelectAll(!isSelectAll)"
              >
                {{ isSelectAll ? "Uncheck All" : "Check All" }}
              </div>
            </div>
            <b-badge variant="light-primary" pill
              >{{ countOfSelected }} Selected</b-badge
            >
          </div>
          <div class="mt-1 modal-site__container">
            <site-item
              v-for="site in siteList"
              :key="site.id"
              v-model="site.isEnable"
              :label="site.name"
            ></site-item>
          </div>
        </div>
      </div>
    </template>
  </molecule-modal-dialog>
</template>

<script>
import MoleculeModalDialog from "@/components/molecules/MoleculeModalDialog.vue"
import { BBadge } from "bootstrap-vue"
import { mapGetters } from "vuex"
import mixinsSiteHelper from "@/mixins/mixinsSiteHelper"
import SiteItem from "./SiteItem.vue"
import mixins from "@/mixins"

export default {
  name: "ModalSiteSelect",
  components: { MoleculeModalDialog, BBadge, SiteItem },
  mixins: [mixins, mixinsSiteHelper],
  props: {
    modalId: {
      type: String,
      require: true,
    },
  },
  data() {
    return {
      siteList: [],
    }
  },
  computed: {
    ...mapGetters("siteStore", ["siteSetting"]),

    countOfSelected() {
      return this.siteList.filter((item) => item.isEnable === true).length
    },

    isSelectAll() {
      return (
        this.siteList.filter((item) => item.isEnable === true).length ===
        this.siteList.length
      )
    },
  },
  watch: {
    async siteSetting() {
      await this.getSiteFromStore()
    },
  },
  async mounted() {
    await this.getSiteFromStore()
  },
  methods: {
    handleSelectAll(isSelected) {
      this.siteList = this.siteList.map((item) => ({
        ...item,
        isEnable: isSelected,
      }))
    },

    confirmSelect() {
      this.$store.dispatch("siteStore/setSite", this.siteList)
      this.$bvModal.hide("modal-site-select")
      this.toastSuccess("Apply Site Select Successful")
    },

    async cancelSiteSelect() {
      await this.getSiteFromStore()
    },

    async getSiteFromStore() {
      this.siteList = await JSON.parse(JSON.stringify(this.siteSetting))
    },
  },
}
</script>

<style lang="scss" scoped>
.modal-site__label {
  font-weight: 600;
  font-size: 14px;
  color: #6e6b7b;
}

.modal-site__check {
  font-weight: 500;
  font-size: 12px;
  color: #b9b9c3;
  cursor: pointer;

  &:hover {
    text-decoration-line: underline;
    color: #7367f0;
  }
}

.modal-site__container {
  gap: 13px;
  display: flex;
  flex-direction: column;
  max-height: calc(100vh - 500px);
  overflow-y: auto;
}
</style>
